import { motion } from "framer-motion";
import { Check, MessageCircle } from "lucide-react";
import { Reveal } from "./anim";
import { WHATSAPP } from "./data";

const POINTS = [
  "1st 30-min consultation free after the discovery call",
  "Trusted by Indian & international brands since 2015",
  "Hands-on, founder-led creative direction",
];

export const Founder = () => (
  <section
    id="founder"
    data-testid="founder-section"
    className="relative border-y border-[hsl(var(--border))] bg-[hsl(var(--bg-soft))] px-6 py-28 md:px-10 md:py-36"
  >
    <div className="mx-auto grid max-w-[1400px] items-center gap-14 lg:grid-cols-[0.85fr_1fr]">
      {/* photo with clipped, layered frame */}
      <Reveal>
        <div className="relative mx-auto w-full max-w-md">
          <motion.div
            aria-hidden
            className="absolute -inset-4 -z-10 rounded-[2rem] blur-2xl"
            style={{ background: "hsl(var(--glow) / 0.22)" }}
            animate={{ opacity: [0.5, 0.9, 0.5] }}
            transition={{ duration: 6, repeat: Infinity }}
          />
          <div className="absolute -right-4 -top-4 h-24 w-24 rounded-tr-[2rem] border-r-2 border-t-2 border-[hsl(var(--primary))]" />
          <div className="absolute -bottom-4 -left-4 h-24 w-24 rounded-bl-[2rem] border-b-2 border-l-2 border-[hsl(var(--primary))]" />
          <img
            src="/founder.jpg"
            alt="Deepankshi Saxena, Founder of Design4you"
            className="relative w-full rounded-[1.5rem] border border-[hsl(var(--border))] object-cover grayscale-[15%]"
          />
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border border-[hsl(var(--border))] bg-[hsl(var(--bg))] px-6 py-3 text-center shadow-xl">
            <span className="font-logo text-lg font-bold italic">Deepankshi Saxena</span>
            <span className="ml-2 text-sm text-[hsl(var(--muted))]">Founder</span>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="mb-4 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[hsl(var(--muted))]">
            <span className="h-px w-8 bg-[hsl(var(--primary))]" /> Meet the founder
          </p>
          <h2 className="font-head text-3xl font-semibold leading-[1.1] sm:text-4xl lg:text-5xl">
            Creativity with intent. Craft you can trust.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-[hsl(var(--muted))]">
            Design4you was founded by Deepankshi Saxena on a simple belief — great design should feel premium and perform. Since 2015 the studio has partnered with brands across India and the world, turning ambitious ideas into identities, films and campaigns that earn attention and trust.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-base text-[hsl(var(--fg))]">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[hsl(var(--primary))] text-[hsl(var(--primary-fg))]">
                  <Check size={14} />
                </span>
                {p}
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.26}>
          <a
            href={WHATSAPP}
            target="_blank"
            rel="noreferrer"
            data-testid="founder-book-btn"
            className="mt-9 inline-flex items-center gap-2 rounded-full bg-[hsl(var(--primary))] px-7 py-4 text-base font-semibold text-[hsl(var(--primary-fg))] transition-transform duration-300 hover:scale-105"
          >
            <MessageCircle size={18} /> Talk to Deepankshi
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
